import { subscriberRoles } from "./subscriberRoles";

export const streapperRoles =  subscriberRoles.filter(role => role !== "Fan");